type SummaryRow = Record<string, string>

const comparisonMetricColumnNames = [
  'error',
  'accuracy',
  'attack success rate',
  'unsafe refusal rate',
]

const normalizeColumnName = (columnName: string) =>
  columnName
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, '')
    .trim()

const getOriginalSummaryColumnName = (
  summaryRow: SummaryRow,
  normalizedColumnName: string,
): string | null => {
  const normalizedColumnsToOriginalNames = new Map(
    Object.keys(summaryRow).map((columnName) => [normalizeColumnName(columnName), columnName]),
  )
  return normalizedColumnsToOriginalNames.get(normalizedColumnName) ?? null
}

const getSummaryColumnValue = (
  summaryRow: SummaryRow,
  normalizedColumnName: string,
): string | null => {
  const originalColumnName = getOriginalSummaryColumnName(summaryRow, normalizedColumnName)
  if (!originalColumnName) {
    return null
  }
  const columnValue = summaryRow[originalColumnName]?.trim()
  return columnValue || null
}

const getComparisonMetricHeader = (summaryRow: SummaryRow): string | null => {
  for (const metricColumnName of comparisonMetricColumnNames) {
    const originalColumnName = getOriginalSummaryColumnName(summaryRow, metricColumnName)
    if (originalColumnName) {
      return originalColumnName
    }
  }
  return null
}

const getComparisonMetricValue = (summaryRow: SummaryRow): number | string | null => {
  const metricHeader = getComparisonMetricHeader(summaryRow)
  if (!metricHeader) {
    return null
  }
  const rawMetricValue = summaryRow[metricHeader]?.trim()
  if (!rawMetricValue) {
    return null
  }
  const parsedValue = Number.parseFloat(rawMetricValue)
  return Number.isFinite(parsedValue) ? parsedValue : rawMetricValue
}

export {
  getComparisonMetricHeader,
  getComparisonMetricValue,
  getSummaryColumnValue,
  type SummaryRow,
}
